module.exports = __webpack_public_path__ + "img/icons8-play-button-fluent.2c047529.svg";